import { api } from '../../api'

export const updateTicketSectionsService = async (
  ticketId: string,
  requestBody: { eventItemId: string; ticketQuantity: number }[]
) => {
  await api.put(` /api/backoffice/tickets/${ticketId}`, requestBody)
}
